import {bus} from '@/main';
/*eslint-disable */
import toast from '@/services/toast';

export default {
  name: 'multiple-delete-demo-req-popup',
  components: {},
  props: ['demoReqIDs'],
  data () {
    return {
      submitted:false
    }
  },
  computed: {

  },
  mounted () {
    console.log(this.demoReqIDs)
  },
  methods: {
    closeDemoRequestInfoPopup() {
      bus.$emit('multiDemoReqDeletedStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    demoForRequestSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            id:this.demoReqIDs
          }
          this.$store.dispatch('deleteDemoRequestByIdAction', data)
            .then((res) => {  
              this.$store.dispatch('getAllDemoRequestListAction')
              toast.success(res.data.msg || 'Reuest Demo deleted successfully');
              this.submitted =  false;
              this.closeDemoRequestInfoPopup();
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },

  }
}